function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{clip-path:url(#SVGID_2_);}\n");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "SVGID_1_",
  width: 512,
  height: 512
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M452.2,243l-1.4-2.5l42.5-42.5c6.8-6.8,10.6-16,10.6-25.6c0-20-16.3-36.3-36.3-36.3c-4.1,0-8,0.8-11.7,2.1V32 c0-13.2-10.8-24-24-24H182.6c-6.4,0-12.4,2.5-17,7L95,85.7c-4.5,4.5-7,10.6-7,17v17.8C43.2,124.5,8,162.2,8,208v256 c0,22.1,17.9,40,40,40h96c22.1,0,40-17.9,40-40v-8h192h8h113.4L480,351.2C479.8,313.5,470.3,276.1,452.2,243 M463.8,345.9l-78,21.3 l-18.8-15c-9.5-7.6-15-19-15-31.2V256v-8c8.8,0,16,7.2,16,16v56h16v-12.7l55-55C454.4,281.1,462.9,313.3,463.8,345.9 M352,232 c-8.8,0-16,7.2-16,16v8c0,4.4-3.6,8-8,8c-4.4,0-8-3.6-8-8v-8c0-17.6,14.4-32,32-32h20.7l-16.4,16.4C354.8,232.2,353.5,232,352,232  M264.4,368.6l10.5-26.3l22.8,22.8l-26.3,10.5c-3.4,1.4-7.4-1.4-7.4-5C264,369.9,264.1,369.2,264.4,368.6 M312,356.7L283.3,328 l48.4-48.4c1.5-0.2,2.9-0.6,4.3-1.1v42.4c0,3.6,0.4,7.2,1.1,10.7L312,356.7z M305.5,264H216v-32h90.8c-1.8,5-2.8,10.4-2.8,16v8 C304,258.8,304.6,261.5,305.5,264 M216,280h92.7l-32,32H216V280z M216,328h47.4l-12.8,32H216V328z M216,376h32.8 c2.4,9.2,10.7,16,20.6,16c2.7,0,5.4-0.5,8-1.5L296,383v25h-80V376z M312,376.6l4.5-1.8l26.6-26.6c0.3,0.5,0.6,1,0.9,1.6V408h-32 V376.6z M360,367l16,12.8V408h-16V367z M488,172.3c0,5.4-2.1,10.5-5.9,14.3L384,284.7V264c0-10-4.7-18.9-12-24.7l81.3-81.3 c3.8-3.8,8.9-5.9,14.3-5.9C478.9,152,488,161.1,488,172.3 M168,35.3V80c0,4.4-3.6,8-8,8h-44.7L168,35.3z M96,136 c39.7,0,72,32.3,72,72s-32.3,72-72,72s-72-32.3-72-72S56.3,136,96,136 M56,286.3c12,6.2,25.6,9.7,40,9.7s28-3.6,40-9.7V328H56 V286.3z M144,488H48c-13.2,0-24-10.8-24-24V258.4c4.6,6.5,9.9,12.4,16,17.4V328c0,8.8,7.2,16,16,16h80c8.8,0,16-7.2,16-16v-52.2 c6.1-5,11.4-10.9,16-17.4V464C168,477.2,157.2,488,144,488 M184,440V208c0-45.8-35.2-83.5-80-87.6V104h56c13.2,0,24-10.8,24-24V24 h248c4.4,0,8,3.6,8,8v116.7L388.7,200H352c-14.2,0-26.9,6.2-35.7,16H200v208h176v16H184z M392,440v-57.9l73.6-20.1l13,78H392z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M88,246.8V264h16v-17.2c9.2-2.9,16-11.5,16-21.7c0-8.7-4.8-16.5-12.6-20.4L91.8,197c-2.3-1.2-3.8-3.5-3.8-6.1 c0-3.8,3.1-6.8,6.8-6.8h2.3c3.8,0,6.8,3.1,6.8,6.8v9.2h16v-9.2c0-10.2-6.8-18.7-16-21.7V152H88v17.2c-9.2,2.9-16,11.5-16,21.7 c0,8.7,4.8,16.5,12.6,20.4l15.6,7.8c2.3,1.2,3.8,3.5,3.8,6.1c0,3.8-3.1,6.8-6.8,6.8h-2.3c-3.8,0-6.8-3.1-6.8-6.8V216H72v9.2 C72,235.4,78.8,243.9,88,246.8"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M136,360H56c-8.8,0-16,7.2-16,16v80c0,8.8,7.2,16,16,16h80c8.8,0,16-7.2,16-16v-80 C152,367.2,144.8,360,136,360 M136,392h-16v-16h16V392z M104,456H88v-16h16V456z M104,424H88v-16h16V424z M72,424H56v-16h16V424z  M88,376h16v16H88V376z M72,392H56v-16h16V392z M56,440h16v16H56V440z M120,456v-48h16l0,48H120z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M424,40H200v48h224V40z M408,72H216V56h192V72z"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 200,
  y: 104,
  className: "st0",
  width: 224,
  height: 16
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 200,
  y: 136,
  className: "st0",
  width: 224,
  height: 16
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  x: 200,
  y: 168,
  className: "st0",
  width: 128,
  height: 16
});

var SvgAnalysis = function SvgAnalysis(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("g", null, _ref3, /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAnalysis, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/analysis.15f0bc0f.svg";
export { ForwardRef as ReactComponent };